import { Link } from "react-router-dom";
import PageShell from "@/components/PageShell";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found | Juwai Morning Teer" description="Not found" path="/404" noindex />
      <PageShell>
        <div className="py-16 text-center">
          <h1 className="font-display text-5xl font-black text-emerald-950">404</h1>
          <p className="text-slate-600 mt-2">Page not found.</p>
          <Link
            to="/"
            className="mt-6 inline-block rounded-full bg-emerald-950 text-white px-5 py-2 font-semibold"
            data-testid="notfound-home"
          >
            Back to home
          </Link>
        </div>
      </PageShell>
    </>
  );
}
